import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IBaseDto } from '@http/clients/reporting-app/base-dto.service';
import { MarketService } from '@http/clients/reporting-app/market.service';
import { ReportsService } from '@services/reports.service';
import { EditorComponentBase, GenericDropdownMultiselectComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reporting-market-editor',
    templateUrl: './reporting-market-editor.component.html',
    styleUrls: ['./reporting-market-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportingMarketEditorComponent extends EditorComponentBase<number[] | null> implements OnInit, OnDestroy {
    items: IBaseDto[];
    selectedItems?: IBaseDto[];
    subscription?: Subscription;

    constructor(
        private readonly reportingMarketService: MarketService,
        private readonly reportsService: ReportsService
    ) {
        super();
        this.items = [];
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    async ngOnInit(): Promise<void> {
        this.items = await this.reportingMarketService.getAll();
        this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
            if (
                ready &&
                this.items?.length &&
                this.bindingProperty !== null &&
                this.bindingProperty?.length &&
                Array.isArray(this.bindingProperty)
            ) {
                this.selectedItems = this.items.filter(
                    (obj) => this.bindingProperty?.find((id) => id === obj['id']) !== undefined
                );
            } else if (ready && (this.bindingProperty === null || this.bindingProperty === undefined)) {
                this.selectedItems = [];
            }
        });
    }

    onSelectedItemsChange() {
        if (this.selectedItems?.length) {
            this.bindingProperty = this.selectedItems.map((obj) => obj.id);
        } else {
            this.bindingProperty = null;
        }
        this.valueChange.emit();
    }
}
